import dayjs from 'dayjs';

// Pure helpers for the reader pages and the admin gate. No React, no API:
// everything here is unit-tested on the live fixtures captured 2026-10-16.

export const ADMIN_PERMISSION = 'releasenote-admin';
export const FEED_PATH = '/dashboard/release-notes';
export const ADMIN_PATH = '/dashboard/settings/release-notes';
export const PAGE_SIZE = 10;

export const releaseNoteStatusMap = {
  0: { tone: 'amber', label: 'Draft' },
  10: { tone: 'emerald', label: 'Published' },
};

// First publish splits the admin's fullname into first/last; a one-word name
// leaves the last name blank, an unpublished draft leaves both null.
export const publisherName = (note) =>
  [note?.publisherfirstname, note?.publisherlastname]
    .map((part) => (part || '').trim())
    .filter(Boolean)
    .join(' ');

// Viewer-local calendar day, the dashboard's convention everywhere else.
export const formatPublishedAt = (iso) =>
  iso ? dayjs(iso).format('MMM D, YYYY') : '';

export const permalink = (origin, slug) => `${origin}${FEED_PATH}/${slug}`;

// Fail closed: authSlice seeds roles/rolepermissions with JSON.parse of
// localStorage, which is null before any login in this tab.
export const canManageReleaseNotes = (roles, rolepermissions) =>
  (Array.isArray(roles) && roles.includes(100)) ||
  (Array.isArray(rolepermissions) && rolepermissions.includes(ADMIN_PERMISSION));

export const countLabel = (total) => {
  const n = Number(total || 0);
  return n === 1 ? '1 update' : `${n.toLocaleString('en-US')} updates`;
};

// The paged envelope carries pageNumber/totalPages; nextPage is a URL we never
// follow (it is http:// on api-test).
export const hasMore = (paged) =>
  Boolean(paged) && Number(paged.pageNumber) < Number(paged.totalPages);

// 400 and 422 answer a plain string; other controllers answer { message } or
// { Message }; a 404 is ProblemDetails with neither — callers check status.
// A proxy's HTML error page (502/520/403) is a string too: never show it.
export const apiErrorText = (err, fallback) => {
  const data = err?.response?.data;
  if (typeof data === 'string' && data.trim() && !data.trim().startsWith('<')) return data;
  return data?.message || data?.Message || fallback;
};

export const isNotFound = (err) => err?.response?.status === 404;
export const isForbidden = (err) => err?.response?.status === 422;

export const feedQuery = ({ pageNumber = 1, tag = '', search = '' } = {}) => {
  const params = new URLSearchParams();
  params.set('pageNumber', String(pageNumber));
  params.set('pageSize', String(PAGE_SIZE));
  if (tag) params.set('tag', tag);
  if (search) params.set('search', search);
  return `?${params.toString()}`;
};
